import React from 'react'
import PhoneSalesBanner from '@pcln/phone-sales-banner'
import { Box } from 'pcln-design-system'
import styled from 'styled-components'
import { getPhoneNumber } from '../../util/phoneSalesBanner/phoneSalesBanner'

const Wrapper = styled(Box)`
  ${({ theme, isPackageListings, $disableSticky }) =>
    $disableSticky
      ? `
    position: relative;
    z-index: 0;
    top: 0px;
  `
      : `
    position: sticky;
    z-index: 10;
    top: ${isPackageListings ? 70 : 73}px;
    ${theme.mediaQueries.sm} {
      position: relative;
      top: 0px;
      z-index: 0;
    }
`}
`

const PhoneSalesBannerWrapper = ({
  isDesktop,
  searchRefId,
  phoneBookInfo,
  hidePhoneSalesBanner = false,
  showIcon = false,
  isPackageListings = false,
  disableSticky = false,
}) =>
  !hidePhoneSalesBanner && (
    <Wrapper
      px={[2, 2, 2, 2, 0]}
      pb={2}
      color='background.lightest'
      isPackageListings={isPackageListings}
      $disableSticky={disableSticky}
    >
      <PhoneSalesBanner
        phoneNumber={phoneBookInfo?.phoneNumber || getPhoneNumber(!isDesktop, searchRefId)}
        isDesktop={isDesktop}
        leftLabel={isPackageListings ? 'Never miss out on a deal!' : 'Priceline Phone Deals'}
        leftSubLabel={isPackageListings ? 'Book with an expert.' : 'Book with an agent for great rates!'}
        iconBgColor='secondary.base'
        imageUrl={'https://s1.pclncdn.com/design-assets/fly-images/phone-rep-image.webp'}
        showIcon={showIcon}
      />
    </Wrapper>
  )

export { PhoneSalesBannerWrapper as PhoneSalesBanner }
